import { AnchorHTMLAttributes, ButtonHTMLAttributes, MouseEventHandler } from 'react';
import { ButtonSize, ButtonVariant } from './enums';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'> & {
    variant?: ButtonVariant;
    size?: ButtonSize;
    fullWidth?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    /**
     * **Deprecated:** Use `href`
     * @deprecated 27/05/2021
     */
    link?: string;
    /**
     * **Deprecated:** Use `title`
     * @deprecated 27/05/2021
     */
    tooltip?: string;
    /**
     * **Deprecated:** Use `disabled`
     * @deprecated 27/05/2021
     */
    isDisabled?: boolean;
  };

export const Button = ({
  children,
  variant = ButtonVariant.Primary,
  size = ButtonSize.Medium,
  fullWidth = false,
  href,
  link,
  title,
  tooltip,
  disabled,
  isDisabled = false,
  className,
  ...props
}: ButtonProps) => {
  const classNames = joinClassNames(
    styles.button,
    styles[variant],
    styles[size],
    (disabled || isDisabled) && styles.disabled,
    fullWidth && styles.fullWidth,
    className
  );

  return href || link ? (
    <a className={classNames} href={href || link} title={title || tooltip} {...props}>
      {children}
    </a>
  ) : (
    <button className={classNames} title={title || tooltip} disabled={disabled || isDisabled} {...props}>
      {children}
    </button>
  );
};

Button.displayName = 'Button';
